type TCategory = {
  name?: string
  list: string[]
}

export const availableServices: TCategory[] = [
  {
    name: "Elétrica",
    list: [
      "Lâmpadas",
      "Disjuntores",
      "Arandelas",
      "Sensores de parede",
      "Espelho interruptor",
      "Espelho tomada",
      "Iluminação pública",
      "Foto-células",
    ],
  },
  {
    name: "Piscina",
    list: [
      "Areia para filtro",
      "Filtro",
      "Bomba",
      "Cloro",
      "Algicida",
      "Fungicida",
      "Manutenção do PH",
      "Kit controle PH",
    ],
  },
  {
    name: "Ferramentas",
    list: [
      "Roçadeira a gasolina",
      "Soprador a gasolina",
      "Cortador de grama carrinho a gasolina",
      "Vap",
      "Furadeira",
      "Parafusadeira",
    ],
  },
  {
    name: "Hidráulica",
    list: [
      "Bombas",
      "Caixa D'água",
      "Cisterna",
      "Encanamento",
      "Bombas hidráulicas",
    ],
  },
  {
    name: "Estrutural",
    list: [
      "Pintura",
      "Telhado",
      "Lavação",
      "Porta corta-fogo",
      "Porta Blindex",
    ],
  },
  {
    name: "Jardinagem",
    list: ["Poda de árvores", "Manutenção gramado"],
  },
  {
    name: "Contábil",
    list: ["Contabilidade", "Administradora", "Garantidora"],
  },
  {
    name: "Pavimentação",
    list: ["Manutenção de lajotas", "Manutenção de Pavers"],
  },
  {
    name: "Elevadores",
    list: ["Manutenção", "Reparo"],
  },
  {
    name: "E.T.E",
    list: ["Manutenção"],
  },
  {
    name: "Segurança",
    list: ["Câmera", "Cerca Elétrica", "Concertina", "Sensor de segurança"],
  },
  {
    name: "Incêncio",
    list: [
      "Recarga Exintores",
      "Sistema contra incêncio",
      "Teste mangueira",
      "Hidrante",
      "Luz de emergência",
    ],
  },
  {
    name: "Acesso",
    list: [
      "Portão",
      "Motor Portão",
      "Molas pivotante",
      "Mola de piso",
      "Interfones",
    ],
  },
  {
    name: "Laudos",
    list: ["Para-raio", "E.T.E", "Água piscina", "Alvará bombeiro"],
  },
  {
    name: "Rede pluvial",
    list: ["Caixas de Gordura", "Caixas de Passagem", "Hidro jateamento"],
  },
  {
    name: "Rede de gás",
    list: [
      "Teste estanqueidade rede primária",
      "Teste estanqueidade rede secundária",
    ],
  },
  {
    name: "Eletrônica",
    list: ["Interfone", "Telefone celular", "Computador", "Impressora"],
  },
  {
    name: "Certificados",
    list: ["NR18", "NR35", "NR10", "NR12", "NR06"],
  },
  {
    name: "Limpeza",
    list: [
      "Lixeira container coletora",
      "Cloro",
      "Água sanitária",
      "Detergente",
      "Desinfetante",
      "Sabão líquido",
      "Balde",
    ],
  },
  {
    list: [
      "Pano esfregão",
      "Vassoura",
      "Rodo",
      "Esponja",
      "Carrinho limpeza",
      "Mobil",
      "Pepel higiênico",
      "Limpa pedra",
    ],
  },
]
